import { EN_AU, EN_CA, EN_GB, EN_US, Locales } from '@src/state/session/types'
import { getWFELS, setInLocalStorage } from './localStorage'

const navLanguageToLocal = (lang: string): Locales | null => {
  return !lang || lang.indexOf('-') < 0
    ? null
    : (lang
        .split('-')
        .map((v, i) => (i < 1 ? v : v.toUpperCase()))
        .join('_') as Locales)
}

export const getCurrentLocale = (): Locales => {
  const acceptableLocales: Locales[] = [EN_US, EN_GB, EN_CA, EN_AU]
  const wfeLs = getWFELS()
  if (wfeLs && wfeLs.selectedLocale) {
    return wfeLs.selectedLocale
  }
  const navLocale = acceptableLocales.find(
    val => val === navLanguageToLocal(window.navigator?.language)
  )
  return navLocale || EN_US
}

export const setLocaleToLocalStorage = (locale: Locales): void => {
  setInLocalStorage({
    selectedLocale: locale,
  })
}



// WEBPACK FOOTER //
// ./src/utils/locale.ts